const trains = {
  train: "يدرب", // translated 
  trains: "القطارات", // translated 
  fairConditions: "شروط عادلة", // translated 
  to: "ل", // translated 
  earlier: "سابقًا", // translated 
  later: "لاحقاً", // translated 
  adults: "الكبار", // translated 
  child: "طفل", // translated 
  senior: "كبير", // translated 
  seniors: "كبار السن", // translated 
  price: "سعر", // translated 
  for: "ل", // translated 
  total: "المجموع", // translated 
  selected: "المحدد", // translated 
  prebook: "الحجز المسبق", // translated 
  book: "كتاب", // translated 
  payment: "قسط", // translated 
  return: "يعود", // translated 
  passengers: "ركاب", // translated 
  delivery: "توصيل", // translated 
  summary: "ملخص", // translated 
  checkout: "الدفع", // translated 
  trainToastCorrectFillForm: "يرجى ملء جميع الحقول بشكل صحيح.", // translated 
  fareConditions: "شروط أجرة", // translated 
  travelInfo: "معلومات السفر", // translated 
  remarks: "ملاحظات العملاء", // translated 
  noServices: "لا توجد خدمات", // translated 
  timesAndSeats: "الأوقات والمقاعد", // translated 
  mobileTicket: "تذكرة الجوال", // translated 
  stationTicket: "جمع في المحطة", // translated 
  homeTicket: "اطبع في المنزل", // translated 
  countryCode: "الرقم الدولي", // translated 
  chooseTicket: "اختر طريقة تسليم التذاكر", // translated 
  ticketError: "يرجى اختيار تذكرة لجميع الوجهات", // translated 
  ticketDelivery: "الرجاء تحديد طريقة تسليم التذاكر", // translated 
  passengerDetails: "تفاصيل الركاب", // translated 
  waitWhileProcessingPayment:
    "يرجى الانتظار بينما نقوم بمعالجة دفعتك، لا تقم بتحديث الصفحة أو إغلاقها.", // translated 
  reductionCardId: "معرف بطاقة التخفيض", // translated 
  countryOfResidence: "بلد الإقامة", // translated 
  countryOfBirth: "بلد الميلاد", // translated 
  documentCountry: "بلد الوثيقة", // translated 
  documentNumber: "رقم المستند", // translated 
  expirationDate: "تاريخ انتهاء الصلاحية", // translated 
  documentType: "نوع الوثيقة", // translated 
  travelerDocumentInfo: "معلومات وثيقة المسافر", // translated 
  youth: "شباب", // translated 
  youths: "شباب", // translated 
  departTimeEarlyFirst: "وقت المغادرة (الأقرب أولاً)", // translated 
};




export default trains;
